import { Action, createReducer, on } from '@ngrx/store';
import { StateRequirementState } from '../../models/state-requirement.model';
import {
    getAvailableStatesForRequirementsFailure,
    getAvailableStatesForRequirementsSuccess,
    getStateGlobalRequirementsFailure,
    getStateGlobalRequirementsSuccess
} from '../actions/state-requirement.actions';

export const initialState: StateRequirementState = {
    states: [],
    requirements: [],
    error: undefined
};

const reducer = createReducer(
    initialState,
    on(getAvailableStatesForRequirementsSuccess, (state, action) => ({
        ...state,
        states: action.states
    })),
    on(getAvailableStatesForRequirementsFailure, (state, action) => ({
        ...state,
        error: action.error
    })),
    on(getStateGlobalRequirementsSuccess, (state, action) => ({
        ...state,
        requirements: action.requirements
    })),
    on(getStateGlobalRequirementsFailure, (state, action) => ({
        ...state,
        error: action.error
    }))
);

export function stateRequirementReducer(state: StateRequirementState | undefined, action: Action) {
    return reducer(state, action);
}
